module.exports = __webpack_public_path__ + "img/t4-salmon.bfbaa884.png";